import React from "react";
import Hand from "../Assets/hand.svg";
import Send from "../Assets/send.svg";
import Scroll from "../Assets/scroll.svg";
import { BsArrowDownShort } from "react-icons/bs";
import { Link } from "react-scroll";
function Home1({ Extra }) {
  return (
    <>
      <h1
        className="text-4xl font-semibold mt-[40px] flex gap-2
      lg:text-5xl lg:mt-[0px]  lg:items-center"
      >
        Shreyash Kumar
        <span>
          <img src={Hand} alt="hand" />
        </span>
      </h1>

      {/* Profile */}
      <div className="flex items-center gap-4 my-[20px]">
        <div className="border-t w-16 border-gray-400 "></div>
        Full Stack Developer
      </div>

      {/* Profile Intro */}
      <p className="mb-[40px]">
        I'm a creative Full Stack Developer passionate about designing dynamic
        and user-friendly web applications.{Extra}
      </p>

      <Link to="contact" spy={true} smooth={true} offset={0} duration={500}>
        <button
          className="flex transition-all duration-200
    hover:bg-black items-center gap-2 bg-gray-900
    rounded-xl px-[25px] py-[15px]"
        >
          <span className="text-white">Say hello</span>
          <img className="" src={Send} alt="" />
        </button>
      </Link>

      <br />
      <br />
      <Link
        to="contact"
        spy={true}
        smooth={true}
        offset={0}
        duration={1000}
        className="hidden lg:flex lg:items-center cursor-pointer"
      >
        <span className="w-7">
          <img src={Scroll} alt="scroll" />
        </span>{" "}
        Scroll down <BsArrowDownShort fontSize={"1.3rem"} />
      </Link>
    </>
  );
}

export default Home1;
